import { getToken, getOrgId, getUserType } from '../misc/auth'

export default {
  status: '',
  token: getToken(),
  user: '',
  isAuth: false,
  inited: false,
  currentRoute: {},
  lastedRouteNotAuth: '/gudid',
  previousRoute: '/',
  authRoutes: ['/login'],
  meta: null,
  // userType: getUserType(),
  // userType: 'NOTISPHERE',
  //orgId: getOrgId(),
  //permissions: null,
  selectUserTypes: null,
  organization: null
}
